<template>
  <widget>
    <template v-slot:content>
      <v-row>
        <v-col><b>Billing MTD</b></v-col>
        <v-col><h4>{{ billingAndSales.billingMTDFormatted }}</h4></v-col>
      </v-row>
      <v-row>
        <v-col><b>Sales MTD</b></v-col>
        <v-col><h4>{{ billingAndSales.salesMTDFormatted }}</h4></v-col>
      </v-row>
      <v-row>
        <v-col><b>Backlog</b></v-col>
        <v-col><h4>{{ billingAndSales.backlogFormatted }}</h4></v-col>
      </v-row>
      <v-row>
        <v-col><b>Sales Today</b></v-col>
        <v-col><h4>{{ billingAndSales.salesTodayFormatted }}</h4></v-col>
      </v-row>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'

export default {
  name: 'BillingAndSales',
  components: {Widget},
  computed: {
    billingAndSales () {
      return store.state.dashboard.billingAndSales
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchBillingAndSales')
  }
}
</script>

<style scoped>

</style>
